import React, { Component } from 'react';
import AdminColorDot from './AdminColorDot';

class EnemyTypeList extends Component {
    render() {
        const { enemytypes, onSelectEnemyType, onNewEnemyType } = this.props;

        return (
            <div className='admin_list'>
                <button onClick={onNewEnemyType}>Create New EnemyType</button>

                {enemytypes.map((enemytype, index) => (
                    <button
                        type="button"
                        className="listElement admin-color-list-element"
                        key={enemytype.id || index}
                        onClick={() => onSelectEnemyType(enemytype)}
                    >
                        <AdminColorDot item={enemytype} />
                        {enemytype.name}
                    </button>
                ))}

            </div>
        );
    }
}

export default EnemyTypeList;
